import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/addObjects/translation.seedTypeValues.mutation.gql"
import type {
  TranslationSeedTypeValuesMutation,
  TranslationSeedTypeValuesMutationVariables,
} from "@/v2-backoffice-client/translation/addObjects/__types__/translation.seedTypeValues.mutation"

type Options = MutationHookOptions<
  TranslationSeedTypeValuesMutation,
  TranslationSeedTypeValuesMutationVariables
>

export function useTranslationSeedTypeValuesMutation(options?: Options) {
  return useMutation<
    TranslationSeedTypeValuesMutation,
    TranslationSeedTypeValuesMutationVariables
  >(mutation, options)
}
